import React from 'react';

const DataUsage = () => {
  return (
    <div className="prose prose-gray max-w-none">
      <p className="text-gray-600 leading-relaxed">
        Your information is used to:
      </p>
      <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-600">
        <li>Provide and maintain our services</li>
        <li>Personalize your experience</li>
        <li>Communicate with you about our services</li>
        <li>We will never use your data for training</li>
        <li>We will never sell your personal data to marketing companies or advertisers</li>
      </ul>
    </div>
  );
};

export default DataUsage;